import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";

class CustomFieldTemplate extends Component {
  render() {
    const {
      id,
      classNames,
      label,
      description,
      rawErrors,
      children,
      displayLabel
    } = this.props;
    return (
      <div className={classNames}>
        <div className="row">
          <div className="col-12">
            <div className="row">
              {displayLabel && (
                <div className="col-12 field-label">
                  <label htmlFor={id}>{label}</label>
                </div>
              )}
              {description}
              <div className="col-12">{children}</div>
              <div className="col-12 errors-container pt-2">
                {rawErrors &&
                rawErrors.map((error, index) => (
                  <div className="mm-form-error">
                    <img src="https://azievprdca03.eiq.gr/uploads/error_b459804363.png"/>
                    <span>{error}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomFieldTemplate;
